module.exports = __webpack_public_path__ + "static/media/asap.c832004c.svg";